import styled from 'styled-components'
import { Badge as RSBadge, BadgeProps as RSBadgeProps } from 'reactstrap'

export type BadgeProps = RSBadgeProps

export const Badge = styled(RSBadge)`
  float: right;
  font-family: Poppins;
  font-weight: 600;
  font-size: 12px;
  color: #242735;
  background-color: white;
  border: 1px solid #EEEFF0;
  padding: 8px 15px;
  margin-right: 8px;
  min-width: 120px;
`
